export default "__VITE_ASSET__BCMuPjRr__"